import { Avatar } from '@seek/avatar';
import type { ComponentProps } from 'react';

import {
  AvatarContactedWrapper,
  AvatarContactedWrapperBordered,
} from './AvatarContacted.css';

interface AvatarContactedProps extends ComponentProps<typeof Avatar> {
  hasBeenContacted?: boolean;
}

export const AvatarContacted = ({
  hasBeenContacted = false,
  ...avatarProps
}: AvatarContactedProps) => {
  let wrapperClassName: string | undefined;

  if (hasBeenContacted) {
    wrapperClassName = avatarProps.border
      ? AvatarContactedWrapperBordered
      : AvatarContactedWrapper;
  }

  return (
    <div className={wrapperClassName}>
      <Avatar {...avatarProps} />
    </div>
  );
};
